import React, { useState } from "react";
import styles from "./users.module.css";
import { RxCross1 } from "react-icons/rx";
import UserDetail from "./UserDetail";
import UserReferral from "./UserReferral";
import UserReview from "./UserReview";
import UserDocuments from "./UserDocuments";

const UsersModal = ({ setToggleUsersDetails, itemData, toggleUsersDetails }) => {
  const [toggleContent, setToggleContent] = useState("Details");

  if (!toggleUsersDetails) return null;

  return (
    <div
      className={styles.overlay}   // ← new overlay wrapper
      onClick={() => setToggleUsersDetails(false)} // optional: close on backdrop click
    >
      <div
        className={styles.main}
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal
      >
        <div className={styles.container}>
          <div className={styles.header_div}>
            <span style={{ fontSize: "1.4rem", color: "purple" }}>
              {itemData.first_name} {itemData.last_name}
            </span>
            <RxCross1
              size={"1.5rem"}
              onClick={() => setToggleUsersDetails(false)}
              cursor={"pointer"}
              className="hover:text-red-500 transition-colors"
            />
          </div>

          {/* Tabs indicator (colored bar) */}
          <div className="relative h-1 bg-gray-200 mt-3 mb-1">
            <div
              className="absolute h-full bg-purple-600 transition-all duration-300"
              style={{
                width: "25%",
                left: `${
                  ["Details", "Documents", "Review"].indexOf(toggleContent) * 25
                }%`,
              }}
            />
          </div>

          {/* Tab labels */}
          <div className={styles.content_list}>
            {["Details", "Documents", "Review"].map((item) => (
              <span
                key={item}
                onClick={() => setToggleContent(item)}
                className={`px-4 py-2 font-medium cursor-pointer transition-colors ${
                  item === toggleContent
                    ? "text-purple-600 border-b-2 border-purple-600"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                {item}
              </span>
            ))}
          </div>

          <div className="mt-6 overflow-y-auto max-h-[calc(100vh-180px)]">
            {toggleContent === "Details" && <UserDetail type="users" itemData={itemData} />}
            {toggleContent === "Referral" && <UserReferral itemData={itemData} />}
            {toggleContent === "Review" && (
              <UserReview reviews={["Store", "Product", "Delivery-Man"]} type="users" itemData={itemData}/>
            )}
            {/* Documents tab is missing — add component when ready */}
            {toggleContent === "Documents" && (
              <UserDocuments itemData={itemData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersModal;